export default {
    props: {
        isEditing: {
            type: Boolean,
            default: false
        },
        lng: {
            default () {
                return '116.48287485086534';
            }
        },
        lat: {
            default () {
                return '39.91703756801054';
            }
        },
        zoom: {
            type: Number,
            default () {
                return 11;
            }
        },
        scale: {
            default () {
                return 1;
            }
        },
        showMap: {
            type: Boolean,
            default: true
        }
    }
}